module.exports = __webpack_public_path__ + "img/10 (1).d8045865.jpg";